<template>
  <div class="site-section dark free-demo-wrapper">
    <div class="container">
      <div class="row main">
        <div class="col-6 col">
          <div class="sm-10">
            <FreeDemoForm />
          </div>
        </div>
        <div class="col col-5 offset-1">
          <div class="sm-10">
            <h2 class="h4">
              Get the Training You Need in 3 Easy Steps
            </h2>
            <div class="row steps">
              <div class="col-12 col body-2">
                Contact us to get started. Our sales team will get in touch to answer your questions and give you all the information you need, including training details and pricing options.
              </div>
              <div class="col-12 col body-2">
                See what we have to offer. We will walk you through the program and demonstrate how it will help you achieve your company’s specific goals in a personalized online meeting.
              </div>
              <div class="col-12 col body-2">
                Bring data-driven transformation to your business. Sign up for our business plan and take your team’s data skills to the next level.
              </div>
            </div>
            <div class="row row-logo">
              <div class="col-12">
                <p class="h6">
                  Trusted by employees from:
                </p>
              </div>
              <div class="col-4 sm-4 logo">
                <LogoOracle class="logo-oracle" />
              </div>
              <div class="col-4 sm-4 logo">
                <LogoAmazon class="logo-amazon" />
              </div>
              <div class="col-4 sm-4 logo">
                <LogoWalmart class="logo-walmart" />
              </div>
              <div class="col-4 sm-4 logo">
                <LogoAzercell class="logo-azercell" />
              </div>
              <div class="col-4 sm-4 logo">
                <LogoVisa class="logo-visa" />
              </div>
              <div class="col-4 sm-4 logo">
                <LogoJTI class="logo-jti" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import FreeDemoForm from '../components/FreeDemoForm.vue';
import LogoOracle from '../assets/svg/logos/oracle.svg?vue-component';
import LogoAmazon from '../assets/svg/logos/amazon.svg?vue-component';
import LogoWalmart from '../assets/svg/logos/walmart.svg?vue-component';
import LogoVisa from '../assets/svg/logos/visa.svg?vue-component';
import LogoAzercell from '../assets/svg/logos/azercell.svg?vue-component';
import LogoJTI from '../assets/svg/logos/jti.svg?vue-component';

export default {
  components: {
    FreeDemoForm,
    LogoOracle,
    LogoAmazon,
    LogoWalmart,
    LogoVisa,
    LogoAzercell,
    LogoJTI,
  },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => {});
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();
    return {
      page,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
};

</script>

<style lang="scss" scoped>
  .free-demo-wrapper {
    min-height: 100vh;
    background-color: var(--main-dark);

    .row.main {
      min-height: calc(100vh - 80px);

      .h4 {
        margin-bottom: var(--spacing-36);
      }

      .h6 {
        color: var(--main-light-shade-3);
      }

      .col-5 {
        > div {
          .row-logo {
            padding-left: var(--spacing-16);
            margin-top: var(--spacing-12);
          }
        }
      }

      .col-6,
      .col-5 {
        align-items: center;
        justify-content: center;
        display: flex;

        .steps {
          counter-reset: section;

          .body-2 {
            color: var(--main-light-shade-4);
            padding-left: 72px;
            margin-bottom: var(--spacing-48);

            &:before {
              background-color: var(--main-dark-shade-2);
              border-radius: 50%;
              color: var(--main-dark-shade-3);
              font-size: 18px;
              font-weight: 600;
              line-height: 30px;
              text-align: center;
              counter-increment: section;
              content: counter(section);
              height: 28px;
              position: absolute;
              width: 28px;
              left: 15px;
              top: 0;
              z-index: 1;
            }

            &:after {
              background-color: var(--main-dark-shade-2);
              content: '';
              height: 100%;
              left: 28.25px;
              position: absolute;
              top: 38px;
              width: 1.5px;
            }

            &:last-of-type {
              &:after {
                width: 0;
              }
            }
          }
        }

        .logo svg {
          max-width: 90px;
        }

        .logo:nth-last-child(-n+3) {
          margin-top: 20px;
        }

        .logo-oracle,
        .logo-amazon,
        .logo-visa,
        .logo-azercell {
          width: 120px;
        }

        .logo-walmart {
          width: 130px;
        }

        .logo-jti {
          width: 42px;
        }
      }
    }

    @include bp($bp-phone) {
      .logo {
        display: flex;
        align-content: center;
        justify-content: center;
        height: 75px;
        margin-top: 0 !important;
      }

      .row.main {
        .h6 {
          text-align: center;
        }
      }
    }

    @include bp($bp-mobile) {
      .container {
        .row.main {
          .row.steps {
            margin-bottom: 72px;
          }
        }
      }
    }
  }

  .fa {
    .free-demo-wrapper {
      background-color: var(--main-dark-shade-1);

      .row {
        &.main {
          .h6 {
            color: var(--main-light-shade-4);
          }
        }
      }
    }
  }
</style>
